import { Component, OnInit, HostListener, EventEmitter } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ParamMap, Router, ActivatedRoute } from '@angular/router';
import { ErrorService } from './../error/error.service';
import { BuywifiService } from '../../services/buywifi.service';
import { AppService } from '../../app.service';
import { HttpService } from '../../services/http.service';
import { TravellersService } from '../travelers/travellers.service';
import { TravelersService } from '../travelers/travelers.service';
import { BreadcrumbsService } from '../breadcrumbs/breadcrumbs.service';
import { AccessibilityService } from '../../services/accessibility.service';
import { DatalayerService } from '../../services/datalayer.service';
import { LandingComponent } from '../landing/landing.component';
import { CartService } from './cart/cart.service';
import { APP_TRANSLATE } from '../../app.translation.en';
import { PaymentSelectionComponent } from '../eb/paymentSelection.component';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  loaderTextList = { loaderHeaderText: APP_TRANSLATE.loaderText, loaderSubHeaderText: '' };
  public sessionValue: number;
  public passengerInfo: any;
  public currentSegment: any;
  public price: any;
  public points: any;
  public origin: any;
  public destination: any;
  public wifiKeys = new EventEmitter<boolean>();
  public maxSessionValue = 99;
  public currencyList: any;
  public offerUrl;
  public selectedCurrency: any;
  public showKeyErrorMessage: any;
  emailForm: FormGroup;
  eRgex: RegExp;
  showEmailErrorMsg = false;
  emailTopSet = false;
  isEmailPresent = false;
  updateEmailOverLay = false;
  showCart = true;
  readmoreOverLay = false;
  pos: any;
  lang: any;
  emailLinkText: any;
  ischarter: any;
  isUnconfirmedTicket: any;
  public showEBforPointsBuy = PaymentSelectionComponent.showEBforPointsBuy;
  static showAlternativePaymentConfirmationScreen = false;
  callbackToCardFlowFromEB = false;
  public noOfKeys: any;

  constructor(private router: Router,
    private fb: FormBuilder,
    private appService: AppService,
    private httpService: HttpService,
    private accessibilityService: AccessibilityService,
    private errorService: ErrorService,
    private breadcrumbsService: BreadcrumbsService,
    private translate: TranslateService,
    public buyWifiService: BuywifiService,
    private titleService: Title,
    private travellersService: TravellersService,
    private travelersService: TravelersService,
    private datalayerService: DatalayerService,
    private cartService: CartService,
    private activatedRoute: ActivatedRoute) {
      this.activatedRoute.queryParamMap.subscribe((paramMap?: ParamMap) => {
        const refresh = paramMap?.get('refresh');
        if (refresh) {
          this.showEBforPointsBuy = PaymentSelectionComponent.showEBforPointsBuy;
          this.callbackToCardFlowFromEB = true;
          this.ngOnInit();                    
        }
      });
    }

  ngOnInit() {    
    this.pos = this.appService.getPOS();
    this.lang = this.appService.getLanguage();    
    if(!this.callbackToCardFlowFromEB) {
      this.sessionValue = this.buyWifiService.getSessionValue();
      this.errorService.removeError();
    }
    else {
      this.sessionValue = 0;
    }   
    if (this.appService.isCharter) {
      this.passengerInfo = this.travelersService.getCharterFormData();
      this.passengerInfo.firstName = this.passengerInfo.firstname;
      this.passengerInfo.lastName = this.passengerInfo.secondname;
    } else {
      this.passengerInfo = this.buyWifiService.getPassengerResponse();
    }
    this.ischarter = this.appService.isCharter;
    
    this.eRgex = /^[_a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[_a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,6})$/;
    this.emailForm = this.fb.group({
      'email': ['', [Validators.required,
      Validators.pattern(this.eRgex)]]
    });
    
    if (this.passengerInfo && !this.appService.isCharter) {
      this.isUnconfirmedTicket = this.appService.isUnconfirmedTicket;
      if(this.passengerInfo.reservationInfo.emailAddress !== undefined && this.passengerInfo.reservationInfo.emailAddress !== ''){
        this.buyWifiService.receiptEmailAddress = this.passengerInfo.reservationInfo.emailAddress.toLowerCase();
        this.emailTopSet = true;
        this.isEmailPresent = true;
        this.emailLinkText = "Edit email address";
      }
      else {
        this.emailLinkText = "Add email address";
      }
    }    
    
    if (this.showEBforPointsBuy) {      
      this.currencyList = [];
      this.price = this.buyWifiService.getPointsOfferResponse().points;
      this.origin = this.buyWifiService.getOriginFromFlightResponse();
      this.destination = this.buyWifiService.getDestinationFromFlightResponse();
    }
    else {
      this.currentSegment = this.buyWifiService.getCurrentSegment();
      this.buyWifiService.checkReleaseCall();
      this.price = this.buyWifiService.getCurrentPrice();  
      this.currencyList = this.buyWifiService.getCurrencyList();
      this.selectedCurrency = this.buyWifiService.getCurrency();
      this.buyWifiService.selectedCurrency = this.selectedCurrency;      
    }    
    this.titleService.setTitle('Onboard wifikeys - SAS');
    this.datalayerService.pushInformationToDataLayer('wifi-keys');
    this.accessibilityService.setSkipLinkId('buywifiKeysBlock');
    this.buyWifiService.setCurrentState(0);
    this.appService.hideLoader();
    this.buyWifiService.hideHeaderFooter();
    this.buyWifiService.setChatBotHide();

    if(document.getElementById("turi-float-btn")){
      document.getElementById("turi-float-btn").style.visibility= "hidden"
    }
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event) {
    if (event.target.id === 'buywifiKeysBlock') {
      if (event.keyCode === 107 || event.keyCode === 39) {
        event.preventDefault();
        this.increaseSession();
      }

      if (event.keyCode === 109 || event.keyCode === 37) {
        event.preventDefault();
        this.decreaseSession();
      }
    }
    if (!event.shiftKey && event.target.id === 'buy-wifi-continue-button' && event.keyCode === 9) {
      event.preventDefault();
    }
  }

  increaseSession() {
    if (this.sessionValue < this.maxSessionValue) {
      this.showKeyErrorMessage = false;
      this.sessionValue++;
    }
  }

  decreaseSession() {
    if (this.sessionValue > 0) {
      this.sessionValue--;
    }
  }

  onChangeCurrency(index, event) {
    this.offerUrl = this.currencyList[index].href;
    this.selectedCurrency = this.currencyList[index].rel;
    this.appService.showLoader();
    this.price = '0';
    this.travellersService.doAncillaryOffersCall(this.offerUrl).subscribe(getOffersResponse => {
      if (getOffersResponse.offerId) {
        this.price = this.buyWifiService.getCurrentPrice();
        this.currencyList = this.buyWifiService.getCurrencyList();
        this.appService.hideLoader();
      }
    },
      error => {
        this.errorService.addError(this.travellersService.getDefaultError());
        this.selectedCurrency = this.buyWifiService.getCurrency();
        this.price = this.buyWifiService.getCurrentPrice();
        this.appService.hideLoader();
      })
    this.buyWifiService.selectedCurrency = this.selectedCurrency;

  }

  emailFormSubmit() {
    if (this.emailForm.valid) {
      const loaderTextList = { loaderHeaderText: APP_TRANSLATE.loaderText, loaderSubHeaderText: '' };
      this.appService.showLoaderWithText(loaderTextList);
      this.buyWifiService.receiptEmailAddress = this.email.value;
      this.cartService.doUpdateEmailCall(this.email.value, this.passengerInfo.reservationInfo.reservationPassengerId).subscribe(
        updateEmailResponse => {
          if (updateEmailResponse.status === 'SUCCESS') {
            this.cartService.updatedEmailInPaxResponse(this.email.value);
            this.buyWifiService.receiptEmailAddress = this.email.value;
            this.closeEmailOverlay();
            this.isEmailPresent = true;
            this.emailLinkText = "Edit Email Address";
            this.appService.hideLoaderWithText();            
          } else if (updateEmailResponse.status === 'FAILURE') {
            this.appService.hideLoaderWithText();
            const singleError = [];
            singleError.push(updateEmailResponse.error);
            this.errorService.addError(singleError);
          }
        }, (error) => {
          this.appService.hideLoaderWithText();
          this.errorService.addError(error);
        }
      );
    } else {
      this.showEmailErrorMsg = true;
    }
  }

  cartButtonEvent() {
    if (this.sessionValue < 1) {
      this.showKeyErrorMessage = true;
    }
  }

  updateActivateOverlay() {
    this.appService.addScrollBody();
    this.errorService.removeError();
    this.appService.removeCustomerErrors();
    LandingComponent.showActivateScreen = false;
    this.appService.scrollToTop();
  }

  readmoreContent() {
    this.readmoreOverLay = true;
    this.buyWifiService.readmoreContent(this.pos,this.lang);
  }

  closeOverlay() {
    this.readmoreOverLay = false;
  }

  get showAlternativePaymentConfirmationScreen() {
    this.noOfKeys = this.buyWifiService.getSessionValue();
    return ProductsComponent.showAlternativePaymentConfirmationScreen;
  }

  closeAlternatePaySelectionOverlay() {
    ProductsComponent.showAlternativePaymentConfirmationScreen = false;
  }

  redirectToBuywifi() {
    ProductsComponent.showAlternativePaymentConfirmationScreen = false;
    this.travellersService.redirectCardFlowFromEBAfterError();
  }

  loadUpdateEmailOverLay(event) {
    this.errorService.removeError();
    this.updateEmailOverLay = true;
    event.preventDefault();
    this.accessibilityService.focus('.sasPaymentPayNowButton');
    this.accessibilityService.focus('#receipt-msg');
  }

  closeEmailOverlay() {
    this.updateEmailOverLay = false;
    this.showEmailErrorMsg = false;
    this.errorService.removeError();
  }

  get email() {
    return this.emailForm.get('email');
  }

  focusUpdateEmailCloseButton(event) {
    event.preventDefault();
    this.accessibilityService.focus('#update-modal-close');
  }

  //TBR
  shiftTabFromEmailClose(event) {
    event.preventDefault();
    if (this.emailForm.invalid) {
      this.accessibilityService.focus('#update-email-input');
    } else {
      this.accessibilityService.focus('#update-email-connect');
    }
  }

  //TBR
  tabFromEmailInput(event) {
    if (this.emailForm.invalid) {
      this.accessibilityService.updateAttributeValue('#update-email-input','aria-invalid', 'true');
    } else {
      this.accessibilityService.updateAttributeValue('#update-email-input','aria-invalid', 'false');
    }
  }

  //TBR
  keytabFocus(event, id) {
    this.accessibilityService.focus(id);
    event.preventDefault();
  }

  //TBR
  keyshiftTabFocus(event, id) {
    if (event.shiftKey && event.key === 'Tab') {
      this.accessibilityService.focus(id);
      event.preventDefault();
    }
  }

  //TBR
  onActiveEmail() {
    this.showEmailErrorMsg = false;
    this.checkEmailState('focused');
  }

  //TBR
  onBlurEmail() {
    this.showEmailErrorMsg = true;
    this.checkEmailState('blur');
  }

  //TBR
  checkEmailState(state) {
    if (state === 'focused' || this.email.value) {
      this.emailTopSet = true;
    } else {
      this.emailTopSet = false;
    }
  }

  //TBR
  @HostListener('window:keydown', ['$event'])
  keyboardEents(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeEmailOverlay();
    }
  }

}
